
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd003-card-II',
    templateUrl: './cd003-card-II.component.html'
})

export class Cd003CardIIComponent extends GeneralComponent implements OnInit {
    public listPreviaNumeroPassada?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listRegulagemPasse?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listPreviaNumeroPassadaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listRegulagemPasseOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listNumeroDaRegulagem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listNumeroDaRegulagemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public formulario?: FormGroup;
    public readonlyRecobrimentosRolo?: boolean;
    @Output() mkCalc = new EventEmitter();
    @Output() getDados = new EventEmitter();

    @ViewChild('txtCheckNumeroPassada') txtCheckNumeroPassada: ElementRef;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Controle do Lote', false);
        if (this.isBasica) {
            this.formulario = this.formBuilder.group({
                controle_analise_ca: [null, [Validators.required]],
                //numero_regulagem_passe: [null, [Validators.required]],
                previa_numero_passada_basica: [null, [Validators.required]],
                regulagem_passe: [null, [Validators.required]],
                Recobrimento_rolos: [null, []]
            });
            this.readonlyRecobrimentosRolo = false;
        } else {
            this.formulario = this.formBuilder.group({
                controle_analise_ca: [null, []],
                previa_numero_passada: [null, []],
                numero_da_regulagem: [null, []],
                Recobrimento_rolos: [null, []]
            });
            this.readonlyRecobrimentosRolo = false;
        }

    }

    public async ngOnInit(): Promise<void> {
      await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
      await Promise.all([
          this.getlistPreviaNumeroPassada(),
          this.getlistRegulagemPasse(),
          this.getlistNumeroDaRegulagem()
      ]);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async checkPreviaNumeroPassada(): Promise<void> {
        const checkPreviaNumeroPassada = this.formulario.get('previa_numero_passada').value as string;
        if (!!checkPreviaNumeroPassada) {
            if (Number(checkPreviaNumeroPassada) < 0 || Number(checkPreviaNumeroPassada) > 15) {
                // tslint:disable-next-line: max-line-length
                this.notificationService.sendNotification('O valor do campo Previa Número Passada tem que ser entre 0 até 15', TypeMessage.Personalized, ActionMessage.Info);
                this.formulario.get('previa_numero_passada').reset();
                this.txtCheckNumeroPassada.nativeElement.focus();
            } else {
                this.makeCalculations();
            }
        }
    }

    async getlistPreviaNumeroPassada(): Promise<void> {
      await this.formularioService.getListDropDownList('cd003', 'previa_numero_passada_basica').pipe(take(1)).toPromise().then(response => {
          if (!!response?.data) {
              this.listPreviaNumeroPassada = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
              this.listPreviaNumeroPassadaOriginal = this.listPreviaNumeroPassada;
          }
      }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
      });
    }

    async getlistRegulagemPasse(): Promise<void> {
      await this.formularioService.getListDropDownList('cd003', 'regulagem_passe').pipe(take(1)).toPromise().then(response => {
          if (!!response?.data) {
              this.listRegulagemPasse = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
              this.listRegulagemPasseOriginal = this.listRegulagemPasse;
          }
      }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
      });
    }

    async getlistNumeroDaRegulagem(): Promise<void> {
      await this.formularioService.getListDropDownList('cd003', 'numero_da_regulagem').pipe(take(1)).toPromise().then(response => {
          if (!!response?.data) {
              this.listNumeroDaRegulagem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
              this.listNumeroDaRegulagemOriginal = this.listNumeroDaRegulagem;
          }
      }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
      });
    }

    async createFilterNumeroRegulagem(value?: string): Promise<void> {
      if (!!value && value.length > 0) {
          if (this.listNumeroDaRegulagemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
              this.listNumeroDaRegulagem = this.listNumeroDaRegulagemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
          } else {
              this.listNumeroDaRegulagem = this.listNumeroDaRegulagemOriginal;
          }
      } else {
          this.listNumeroDaRegulagem = this.listNumeroDaRegulagemOriginal;
      }
  }

    async getDadosMateriaPrima(){
      this.getDados.emit();
    }

}

